import React from "react";

const SvgEditProfile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
  >
    <g clipPath="url(#clip0_6140_2572)">
      <path
        d="M8.50127 14.7008H1.35C0.88083 14.7008 0.5 14.32 0.5 13.8508V12.6808C0.5 10.8701 1.96927 9.40078 3.78 9.40078H4.14342C4.80549 9.68784 5.53278 9.85078 6.3 9.85078C7.06657 9.85078 7.79643 9.68811 8.45695 9.40078H8.82C9.62136 9.40078 10.3518 9.69591 10.9206 10.1825L9.10207 12.001L8.87988 12.2232L8.75528 12.3478L8.73633 12.523L8.70278 12.8334L8.70259 12.8352L8.51153 14.5462L8.51141 14.5473C8.50577 14.5987 8.50243 14.65 8.50127 14.7008ZM10.4069 14.6938L10.5716 13.2171L13.9724 9.8187L15.282 11.1283L11.881 14.5293L10.4069 14.6938ZM9.4 4.40078C9.4 6.11308 8.0123 7.50078 6.3 7.50078C4.58771 7.50078 3.2 6.11308 3.2 4.40078C3.2 2.68849 4.58771 1.30078 6.3 1.30078C8.0123 1.30078 9.4 2.68849 9.4 4.40078ZM16.3836 7.65121L17.4477 8.71525C17.4479 8.71549 17.4482 8.71573 17.4484 8.71597C17.5163 8.78534 17.5163 8.89535 17.4483 8.96471C17.4481 8.96493 17.4479 8.96515 17.4477 8.96537L16.6273 9.7858L15.3155 8.47585L16.1401 7.65121C16.2064 7.58491 16.3173 7.58491 16.3836 7.65121Z"
        stroke="#0C0324"
      />
    </g>
    <defs>
      <clipPath id="clip0_6140_2572">
        <rect
          width="18"
          height="14.4"
          fill="white"
          transform="translate(0 0.800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEditProfile;
